module.exports = __webpack_public_path__ + "img/banner3_1_zh.52cb8192.png";